import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Image,
} from "@chakra-ui/react";
import { useEffect } from "react";

interface Props {
  title: string;
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

export default function ImageModal(props: Props) {
  useEffect(() => {
    props.onOpen();
    // esline-disable-next-line
  }, []);
  return (
    <>
      <Modal isOpen={props.isOpen} onClose={props.onClose} size="xl">
        {/* <ModalOverlay /> */}
        <ModalContent padding={0}>
          <ModalBody padding={0}>
            <ModalCloseButton color="#fff" />
            <Image src="/images/novos-porticos.png" alt="Novos porticos" />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
